import { ActionTree } from 'vuex'
import { THEME_TYPES } from '@/store/mutation-types'
import { RootState } from 'types'
import { ThemeState } from './themeTypes'
import { extractUrlThemeParameters, setThemeVariables } from '@/utils/setup'

export const actions: ActionTree<ThemeState, RootState> = {
  setTheme ({ commit, getters }, config): any {
    commit(THEME_TYPES.SET_THEME, extractUrlThemeParameters(config))
    setTimeout(() => {
      setThemeVariables(getters.theme.colors)
    }, 0)
  }
}
